module.exports = __webpack_public_path__ + "img/q12.b4a31c12.png";